/* Required to simulate position:sticky due to css
   incompatibility with GSAP ScrollSmoother plugin
*/
import { gsap } from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1366,
    xxxl: 1600
};

jQuery(function($) {

    function applySticky(target, matchMedia = false) {
        let breakpoint = target.getAttribute('data-sticky-bp');
        let parent = target.closest('.sticky-parent');
        if (parent) {
            let scrollTriggerConfig = {
                trigger: parent,
                start: 'top top',
                pin: target,
                pinSpacing: false,
            };
            if (parent.classList.contains('js-parallax-fw')) {
                scrollTriggerConfig.end = () => {
                    return '+=' + ((parent.offsetHeight - target.offsetHeight) - parseInt(window.getComputedStyle(target).getPropertyValue('--bs-gutter-x'))).toString();
                };
                scrollTriggerConfig.invalidateOnRefresh = true;
            } else {
                scrollTriggerConfig.endTrigger = parent;
                scrollTriggerConfig.end = 'bottom bottom';
            }
            if (matchMedia) {
                let mm = gsap.matchMedia();
                mm.add('(min-width: ' + breakpoints[breakpoint] + 'px)', () => {
                    ScrollTrigger.create(scrollTriggerConfig);
                });
            } else {
                ScrollTrigger.create(scrollTriggerConfig);
            }
        }
    }

    function initSticky(target) {
        let breakpoint = target.getAttribute('data-sticky-bp');
        if (typeof breakpoint != 'undefined' && breakpoint !== null) {
            applySticky(target, true);
        } else {
            applySticky(target);
        }
    }

    document.querySelectorAll('.sticky-elem').forEach(initSticky);

    document.addEventListener('reload-layout', (event) => {
        let container = event.detail ?? document;
        container.querySelectorAll('.sticky-elem').forEach(initSticky);
    });

});
